import CareerEmpowermentSection from "@/components/about/Career";
import AboutHero from "@/components/about/Hero";
import JoinGrowthSchool from "@/components/about/Job";
import GrowthSchoolWay from "@/components/about/Way";
import Investors from "@/components/home/Investors";
import investorsData from "@/data/investors.json";
import Cards from "@/components/home/Cards";

export default function about() {
  return (
    <div>
      <AboutHero />
      <GrowthSchoolWay />
      <CareerEmpowermentSection />
      <JoinGrowthSchool />
      <Cards />
      <Investors investors={investorsData} />
    </div>
  );
}
